import type { AttendanceSummary, OverviewAttentionItem } from '../types';
import type { TrendPoint } from '../charts';

/** Attendance days arrive as ISO dates; the axis wants something a person can read. */
export function toTrendPoints(series: AttendanceSummary['series'], locale: string): TrendPoint[] {
  return series.map((entry) => ({
    label: new Date(entry.day).toLocaleDateString(locale, { day: 'numeric', month: 'short' }),
    value: entry.rate,
  }));
}

/** HIGH outranks MEDIUM outranks INFO — the sort the attention rail relies on. */
const SEVERITY_RANK: Record<OverviewAttentionItem['severity'], number> = {
  HIGH: 0,
  MEDIUM: 1,
  INFO: 2,
};

export function sortAttention(items: OverviewAttentionItem[]): OverviewAttentionItem[] {
  return [...items].sort(
    (a, b) => (SEVERITY_RANK[a.severity] ?? 3) - (SEVERITY_RANK[b.severity] ?? 3),
  );
}

/** A last-resort human form for an attention kind no locale entry names yet. */
export function humanizeKind(kind: string): string {
  const words = kind.toLowerCase().split('_').join(' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}
